import React from 'react';
import { AuthenticatedTemplate as MsalAuthenticatedTemplate } from '@azure/msal-react';
import { ScimAuthService } from '../services/ScimAuthService';

interface AuthenticatedTemplateProps {
    children: React.ReactNode;
}

export const AuthenticatedTemplate: React.FC<AuthenticatedTemplateProps> = ({ children }) => {
    // Check for direct token authentication (localhost/debug mode)
    const isDirectTokenAuth = ScimAuthService.isAuthenticated() && ScimAuthService.getCurrentAccount()?.environment === 'direct-token';

    // If using direct token, bypass MSAL's AuthenticatedTemplate
    if (isDirectTokenAuth) {
        return <>{children}</>;
    }

    // Otherwise use MSAL's AuthenticatedTemplate
    return (
        <MsalAuthenticatedTemplate>
            {children}
        </MsalAuthenticatedTemplate>
    );
};
